import { Checkbox, Tooltip } from '@mui/material';
import { Shield, ShieldOff } from 'lucide-react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useRecoilState } from 'recoil';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import { showSensitiveInfoState } from '~/state/atoms/viewerAtoms';

const SensitiveInfoToggle = () => {
    const selectedPatient = useSelectedPatient();
    const [showSensitiveInfo, setShowSensitiveInfo] = useRecoilState(
        showSensitiveInfoState
    );

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.ctrlKey && event.key.toLowerCase() === 'h') {
                event.preventDefault();
                if (selectedPatient) {
                    setShowSensitiveInfo((prev) => !prev);
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showSensitiveInfo, setShowSensitiveInfo, selectedPatient]);

    return (
        <Tooltip
            title={
                showSensitiveInfo ? (
                    <FormattedMessage id="hidePatientLabelTooltip" />
                ) : (
                    <FormattedMessage id="showPatientInfoTooltip" />
                )
            }
        >
            <Checkbox
                onChange={() => setShowSensitiveInfo(!showSensitiveInfo)}
                checked={!showSensitiveInfo}
                inputProps={{
                    'aria-label': 'Show sensitive info',
                }}
                icon={<ShieldOff size={16} />}
                checkedIcon={<Shield size={16} />}
                size="small"
                sx={{
                    padding: 1,
                }}
                data-testid="patient-info-toggle"
            />
        </Tooltip>
    );
};

export default SensitiveInfoToggle;
